import { render, staticRenderFns } from "./projectCount.vue?vue&type=template&id=79b77cf2"
import script from "./projectCount.vue?vue&type=script&lang=js"
export * from "./projectCount.vue?vue&type=script&lang=js"
import style0 from "./projectCount.vue?vue&type=style&index=0&id=79b77cf2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports